import { render, staticRenderFns } from "./CreditsSection.vue?vue&type=template&id=b5531582&"
import script from "./CreditsSection.vue?vue&type=script&lang=js&"
export * from "./CreditsSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports